import { render, staticRenderFns } from "./UploadProductsForm.vue?vue&type=template&id=709032a4&"
import script from "./UploadProductsForm.vue?vue&type=script&lang=js&"
export * from "./UploadProductsForm.vue?vue&type=script&lang=js&"
import style0 from "./UploadProductsForm.vue?vue&type=style&index=0&id=709032a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports